import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  newNotificationReceived: false,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNewNotificationReceived(state, action) {
      state.newNotificationReceived = action.payload;
    },
  },
});

export const { setNewNotificationReceived } = notificationSlice.actions;
export default notificationSlice.reducer;
